export default __webpack_public_path__ + "static/media/Encryption_Completed.fd605c81.png";